import { atom, type Getter, type Setter } from 'jotai';
import { store } from '..';
import { updateService } from '../../services/updateService';

// Define atoms for update state
export const hasUpdateAtom = atom<boolean>(false);
export const updateVersionAtom = atom<string | null>(null);
export const isCheckingUpdateAtom = atom<boolean>(false);

// Function to check for updates
const checkForUpdate = async (): Promise<boolean> => {
  return await updateService.checkForUpdate();
};

const updateInterval = 300000; // 5 minutes (300000ms)

// Initialize update monitoring
let updateTimeoutId: ReturnType<typeof setTimeout>;

const checkUpdateStatus = async (get: Getter, set: Setter) => {
  // Only check if we're online (check network status if available)
  try {
    const hasUpdate = await checkForUpdate();

    // Schedule next check based on updateInterval
    updateTimeoutId = setTimeout(
      () => checkUpdateStatus(get, set),
      updateInterval,
    );

    return hasUpdate;
  } catch (error) {
    console.error('Error in update check:', error);
    // Retry after updateInterval even on error
    updateTimeoutId = setTimeout(
      () => checkUpdateStatus(get, set),
      updateInterval,
    );
    return false;
  }
};

// Function to start update monitoring
export const startUpdateMonitoring = () => {
  // Initialize cached version first
  updateService.initializeCachedVersion();

  // Start periodic checking after initial delay
  setTimeout(() => {
    checkUpdateStatus(store.get, store.set);
  }, updateInterval);

  // Return cleanup function
  return () => {
    if (updateTimeoutId) {
      clearTimeout(updateTimeoutId);
    }
  };
};
